import * as React from "react";
import { Axios } from "axios";
import { gql, useQuery } from "@apollo/client";

import { Navbar } from "../../Components/Navbar/Navbar";
import { CardProject } from "../../Components/CardProject/CardProject";
import jumbotronImage from "./../../IMG/Jumbotron.png" 
import profileImage from "./../../IMG/profileimg.png"
import "./home.css";

import { IoLocationSharp } from "react-icons/io5"
import { AiFillPhone, AiFillLinkedin, AiFillInstagram, AiFillGithub, AiOutlineWhatsApp, AiOutlineTwitter, AiFillFacebook  } from "react-icons/ai"
import { MdEmail } from "react-icons/md"

import { useState, useEffect, useContext } from "react";
import Cookies from "js-cookie";

const GetProjects = gql `
query MyQuery {
  porto_projects {
    content
    description
    id
    link
    image_cover
    link
    tags {
      tag {
        id
        name
      }
      id
    }
  }
}


`

export default function Home() {

  const {data, loading, error} = useQuery(GetProjects)
  console.log(data)

  return (
    <div>
      <Navbar/>
      <div className="">
        <div className="jumbotron">
          <div className='container w-full pt-20 pb-40'>
            <div className="w-full grid lg:grid-cols-2">
              <div className="flex justify-center">
                <img alt="Jumbotron" src={jumbotronImage} className="w-112 md:w-320"></img>
              </div>
              <div className="flex items-center">
                <div>
                  <p className="m-0 text-24 lg:text-48">Hi. I'm Faiz.</p>
                  <p className="m-0 text-18 lg:text-36">A Front-end Developer</p>
                  <p className="m-0 text-9 lg:text-10">Experienced using ReactJS and also interest in UI/UX Design</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="projects" id="projects">
          <div className="container pt-40">
            <p className="text-18 lg:text-28 font-500">Related Activities / Experiences</p>
            <div className="">
              <ul className="list-disc grid gap-20">

                <li>
                  <h6 className="text-10 lg:text-12 font-normal"><span className="font-semibold">Developer Intern</span> at dentsu Indonesia</h6>
                  <p className="text-8 lg:text-9">Feb 2023 - Apr 2023</p>
                  <ul className="list-disc">
                    <li className="text-8 lg:text-10">Work and trained using Laravel, VueJS, and Inertia</li>
                    <li className="text-8 lg:text-10">Contributing in a project, responsible frontend web development using Laravel, VueJS, and Inertia under manager supervision</li>
                  </ul>
                </li>

                <li>
                  <h6 className="text-10 lg:text-12 font-normal"><span className="font-semibold">Independent Study</span> at Alterra Academy X Kampus Merdeka</h6>
                  <p className="text-8 lg:text-9">Feb 2022 - Jul 2022</p>
                  <ul className="list-disc">
                    <li className="text-8 lg:text-10">Work and trained to be a professional web developer focus in frontend engineering using ReactJS under mentor supervision and guidence for 5-6 months</li>
                    <li className="text-8 lg:text-10">Complete independent study by creating a website called “VaksinQu” for final project. “VaksinQu” is a vaccine booking system for manage vaccinations</li>
                  </ul>
                </li>

              </ul>
            </div>
          </div>
        </div>

        <div className="projects" id="projects">
          <div className="container pt-40">
            <p className="text-18 lg:text-28 font-500">Skills</p>
            <div className="flex justify-start gap-10 flex-wrap">
              <div className="py-2 px-3 bg-blue-200 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">ReactJS</p>
              </div>
              <div className="py-2 px-3 bg-green-200 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">VueJS</p>
              </div>
              <div className="py-2 px-3 bg-red-200 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">Laravel</p>
              </div>
              <div className="py-2 px-3 bg-orange-200 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">Inertia</p>
              </div>
              <div className="py-2 px-3 bg-teal-200 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">Hasura.io</p>
              </div>
              <div className="py-2 px-3 bg-pink-100 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">GraphQL</p>
              </div>
              <div className="py-2 px-3 bg-light-blue-100 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">TailwindCSS</p>
              </div>
              <div className="py-2 px-3 bg-deep-purple-100 w-fit rounded-lg">
                <p className="m-0 font-medium text-9 lg:text-10">Bootstrap</p>
              </div>
            </div>
          </div>
        </div>

        <div className="projects" id="projects">
          <div className="container pt-40">
            <p className="text-18 lg:text-28 font-500">Project</p>
            <div className="w-full grid lg:grid-cols-3 gap-20">
              {data?.porto_projects.map((project) => <CardProject key={project.id} items={project}/>)}
            </div>
          </div>
        </div>
        <div className="about-me bg-green-50 mt-40 pt-16" id="about-me">
          <div className="container w-full pb-20">
            <p className="text-18 lg:text-28 font-500">About Me</p>
            <div className="grid lg:grid-cols-3">
              <div>
                <img alt="ProfilePicture" src={profileImage} className="mx-auto sm:w-96 lg:w-[300px]"></img>
              </div>
              <div className="lg:col-span-2 flex items-center">
                <div>
                  <p className="text-14 lg:text-16 font-500">Hi. I'm Faiz. </p>
                  <p className="text-9 lg:text-11 ">Fresh graduate from information system UPN Veteran Jakarta. I'm interest in web developing and focus on frontend development.</p>
                </div>
              </div>
            </div>
            <p className="mt-32 text-9 lg:text-11">My name is Muhammad Faiz Hafizh Ramadhan. I am a fresh graduate bachelor degree of information system in UPN Veteran Jakarta. I am particularly drawn to frontend development, where I find the perfect blend of design aesthetics and coding logic. During my studies, I delved into HTML, CSS, JavaScript, and modern frontend frameworks like ReactJS and VueJS. Experienced with working on several projects in my intern, for my thesis, and also for my freelance as web developer. </p>
            <p className="mt-32 text-9 lg:text-11">I'm actively seeking entry-level opportunities in frontend development where I can contribute my creativity, technical acumen, and passion for user-centered design. Let's connect! If you're interested in frontend development, technology, or simply looking to expand your network, I'd be delighted to connect and explore potential opportunities.</p>
          </div>
        </div>
        <div className="contact py-32" id="contact">
          <div className="container">
            <p className="text-18 lg:text-24 font-500">Contact Me</p>
            <div className="grid lg:grid-cols-2">
              <div>
                <div className="flex gap-20 mb-2">
                  <IoLocationSharp size="25px" className="location-icons"/>
                  <p className="m-0">Depok, Jawa Barat</p>
                </div>
                <div className="flex gap-20 mb-2">
                  <AiFillPhone size="25px" className="phone-icons"/>
                  <p className="m-0">081222249165</p>
                </div>
                <div className="flex gap-20 mb-2">
                  <MdEmail size="25px" className="mail-icons"/>
                  <p className="m-0">faizhafizh28@gmail.com</p>
                </div>
              </div>
              <div>
                <p className="mt-10 lg:mt-0">Social Media</p>
                <div className="flex justify-start gap-10">
                  <a href="https://www.instagram.com/faizhafizhr/" target="_blank"><AiFillInstagram size="30px" className="instagram-icons"/></a>
                  <a href="https://github.com/faaizhr" target="_blank"><AiFillGithub size="30px" className="github-icons"/></a>
                  <a href="https://www.linkedin.com/in/faizhafizhramadhan/" target="_blank"><AiFillLinkedin size="30px" className="linkedin-icons"/></a>
                  <a href="https://wa.me/+6281222249165" target="_blank"><AiOutlineWhatsApp size="30px" className="whatsapp-icons"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="text-center text-8 py-10 container copyright-container">
            <p className="m-0">Copyright © 2022 Faiz All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
}
